import { createFileRoute } from '@tanstack/react-router';
import { defaultOrganizationId } from '@nest/ids';
import { requirePermission } from '@/features/auth/access';
import { ConnectionsPage } from '@/features/connection/list-page';
import { PlatformWorkspace } from '@/features/tenant/platform-workspace';

export const Route = createFileRoute('/_authenticated/operations/connections')({
  beforeLoad: ({ context, location }) => {
    if (context.session.session.activeOrganizationId !== defaultOrganizationId)
      return;
    return requirePermission(
      context.queryClient,
      location.href,
      'connections:read',
    );
  },
  component: ConnectionsRoute,
});
function ConnectionsRoute() {
  const { session } = Route.useRouteContext();
  return (
    <PlatformWorkspace session={session}>
      <ConnectionsPage />
    </PlatformWorkspace>
  );
}
